import { makeRequest } from "./api";

export const FetchAccommodationLicense = async (propertyId) => {
  return makeRequest(`/api/admin/tourism/accommodation-license/${propertyId}`);
};

export const VerifyAccommodationLicense = async (formData) => {
  return makeRequest("/api/admin/tourism/verify-accommodation-license", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
};

export const ForceAccommodationLicense = async (formData) => {
  return makeRequest("/api/admin/tourism/force-accommodation-license", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
};
